import styles from './FeaturedOn.module.scss'

/**
 * FeaturedOn — the pre-footer directory badge strip, extracted from `_layout._index.tsx` (narcis
 * wall plan step 6) so the wall's endpaper can mount the identical, unedited component.
 * A badge is a dofollow link out of narcis.ai; it stays only while the directory returns a dofollow,
 * indexable link to narcis.ai — see the badge list's own history in the legacy home before this
 * extraction (git blame `_layout._index.tsx`).
 */
const FEATURED_ON = [
    {
        href: 'https://www.toolpilot.ai',
        src: 'https://www.toolpilot.ai/cdn/shop/files/f-w_690x151_crop_center.png',
        alt: 'Featured on ToolPilot',
        rel: 'noopener',
    },
    {
        href: 'https://fazier.com',
        src: 'https://fazier.com/api/v1//public/badges/launch_badges.svg?badge_type=featured&theme=neutral',
        alt: 'Fazier badge',
        rel: 'noopener',
    },
    {
        href: 'https://auraplusplus.com/projects/narcis-ai-photoshoot-face-swap',
        src: 'https://auraplusplus.com/images/badges/featured-on-light.svg',
        alt: 'Featured on Aura++',
        rel: 'noopener',
    },
    {
        href: 'https://findly.tools/narcis?utm_source=narcis',
        src: 'https://findly.tools/badges/findly-tools-badge-light.svg',
        alt: 'Featured on Findly.tools',
        rel: 'noopener noreferrer',
    },
]

export function FeaturedOn() {
    return (
        <div className={styles.strip}>
            <span className={styles.label}>Featured on</span>
            <div className={styles.badges}>
                {FEATURED_ON.map((b) => (
                    <a key={b.href} href={b.href} target="_blank" rel={b.rel}>
                        <img
                            className={styles.badge}
                            src={b.src}
                            alt={b.alt}
                            loading="lazy"
                            decoding="async"
                        />
                    </a>
                ))}
            </div>
        </div>
    )
}
